import * as React from 'react';

interface ILockProps {
    url: string;
}

export function hasLock(url: string): boolean {
    if (url == null) return false;

    if (url.indexOf("/myaap") > -1)
        return true;
    else if (url.indexOf(".aappublications") > -1)
        return true;
    else if (url.indexOf(".solutions") > -1)
        return true;
    else if (url.indexOf("publications.aap") > -1)
        return true;
    else
        return false;
}

export class Lock extends React.Component<ILockProps, any> {
	

    isLoggedIn(): boolean {
        return (window as any).bootstrap.isLoggedIn;
    }

    render() {
        if (!hasLock(this.props.url))
            return null;
        return (
			<div className="search-result-icon">
                {hasLock(this.props.url) && this.isLoggedIn() &&
					<svg>
						<use xlinkHref="#lock-unlocked"></use>
					</svg>
                }

                {hasLock(this.props.url) && !this.isLoggedIn() &&
					<svg>
						<use xlinkHref="#lock-locked"></use>
					</svg>
                }
            </div>
    )}
}
